import React from "react";
import classnames from "classnames";

import "./Employee.scss";

class Employee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contextMenu: false
    };
  }

  toggleContextMenu = e => {
    e.stopPropagation();
    if (this.state.contextMenu) this.setState({ contextMenu: false });
    else this.setState({ contextMenu: { x: e.clientX, y: e.clientY } });
  };

  render() {
    const {
      name,
      profile_pic,
      islineManager,
      setLineManager,
      unsetLineManager,
      removeEmployee
    } = this.props;
    const { contextMenu } = this.state;
    return (
      <div className="LineManagerSelector_EmployeeContainer">
        {islineManager && <div className="crown" />}
        <div
          onClick={setLineManager}
          className={classnames("LineManagerSelector_Employee clickable", {
            islineManager
          })}
        >
          <img
            src={`/users/${profile_pic || "default_user.png"}`}
            className="profile_pic"
            alt={`Profile pic of ${name}`}
          />
          {name}
          <img
            src="/icons/down-chevron.svg"
            alt="Menu"
            className={classnames("menuButton clickable", {
              "icon-white": !islineManager
            })}
            onClick={this.toggleContextMenu}
          />
        </div>
        {contextMenu && (
          <div>
            <div
              className="contextMenuOverlay"
              onClick={this.toggleContextMenu}
            />
            <div
              className="contextMenu"
              style={{ top: contextMenu.y, left: contextMenu.x }}
            >
              <span
                className="link"
                onClick={e => {
                  removeEmployee();
                  this.toggleContextMenu(e);
                }}
              >
                Remove from entity
              </span>
              <br />
              <span
                className="link"
                onClick={e => {
                  if (!islineManager) setLineManager();
                  else unsetLineManager();
                  this.toggleContextMenu(e);
                }}
              >
                {islineManager ? "Unmark" : "Mark"} as entity manager
              </span>
              <br />
              <a
                href="https://google.com"
                target="_blank"
                rel="noopener noreferrer"
                onClick={this.toggleContextMenu}
              >
                View profile
              </a>
              <br />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Employee;
